import { createClient, ConnectError, Code } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { useAppStore } from "@/stores/app";

import type { Interceptor } from "@connectrpc/connect";
import type { DescService } from "@bufbuild/protobuf";

// On an Unauthenticated response the session is gone, so clear the cached user.
// A watcher in App.vue reacts to that change and routes to the login page.
const authInterceptor: Interceptor = (next) => async (req) => {
  try {
    return await next(req);
  } catch (error: unknown) {
    if (error instanceof ConnectError && error.code === Code.Unauthenticated) {
      useAppStore().clearCurrentUser();
    }
    throw error;
  }
};

export const transport = createConnectTransport({
  baseUrl: window.location.origin,
  useBinaryFormat: false, // Use JSON for easier debugging
  // Send the httpOnly session cookie with every request. Requests are
  // same-origin in production (frontend embedded in the binary) and via the
  // Vite dev proxy in development, so the cookie rides along automatically.
  fetch: (input, init) => fetch(input, { ...init, credentials: "include" }),
  interceptors: [authInterceptor],
});

// Helper to create typed clients
export function createServiceClient<T extends DescService>(service: T) {
  return createClient(service, transport);
}
